import { pxToRem } from '../../utils';
var treeStyles = {
    root: function () { return ({
        display: 'block',
        paddingLeft: "" + pxToRem(10),
    }); },
};
export default treeStyles;
